<template>
<v-card class="pa-4 box-shadow-custom">
    <v-tabs v-model="tab" show-arrows>
        <v-tab class="text-capitalize" to="/details/info">
            <v-icon left>mdi-account</v-icon>
            Summary
        </v-tab>
        <v-tab class="text-capitalize" to="/details/invoices">
            <v-icon left>mdi-lock</v-icon>
            Invoices
        </v-tab>
        <v-tab class="text-capitalize" to="/plans">
            <v-icon left>mdi-currency-usd</v-icon>
            Plans
        </v-tab>
        <v-tab-item value="/details/info">
            <v-skeleton-loader :loading="loading" v-if="info.customer != null || loading" class="mt-10" type="article">
                <Summary :customer="info.customer" />
            </v-skeleton-loader>
            <NoData title="No Billing info found" :button="{title: 'View Plans', path: '/plans'}" v-else />
        </v-tab-item>
        <v-tab-item value="/details/invoices">
            <v-skeleton-loader v-if="info.invoices != '' || loading" :loading="loading" type="article">
                <Invoice :invoices="info.invoices" />
            </v-skeleton-loader>
            <NoData title="No Invoices" :button="{title: 'View Plans', path: '/plans'}" v-else />
        </v-tab-item>
    </v-tabs>
</v-card>
</template>

<script>
import {
    mapActions,
} from "vuex";
export default {
    components: {
        Summary: () => import('../components/Billing/Billing'),
        NoData: () => import('../components/Error/noData'),
        Invoice: () => import('../components/Billing/Invoice')
    },
    data() {
        return {
            tab: null,
            info: [],
            loading: false
        }
    },
    mounted() {
        this.initialize();
    },
    methods: {
        ...mapActions(["GetResponse"]),
        async initialize() {
            this.loading = true
            try {
                let url = '/internal/v2/billing/invoices'
                const data = (await this.GetResponse(url)).data
                if (data.success) {
                    this.info = data.data
                    this.loading = false
                }
                this.loading = false
            } catch (err) {
                console.log(err)
                this.loading = false
            }
        }
    },
}
</script>
